import script from "./BegrenzungInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BegrenzungInfo.vue?vue&type=script&setup=true&lang=js"

import "./BegrenzungInfo.vue?vue&type=style&index=0&id=5a713164&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a713164"]])

export default __exports__